import { Svg } from 'components/svg'
import type { IconType } from 'models.d'

export const IconClose: IconType = ({ className = '', ...props }) => (
  <Svg
    {...props}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 23L1 1"
      stroke="#F9F9F9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 1L1 23"
      stroke="#F9F9F9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)
